import React from 'react';
import { useRouter } from 'next/router';

import { useAuthContext } from '../../../context/Auth';

import { CFColorTokenProp } from '../../../theme/tokens/contentful-color';

import { Flexbox } from '../../Flexbox';
import { Box } from '../../Box';
import { Text } from '../../Text';

import { SharedProps, WidgetProps } from '../shared';
import { Button, TransparentButton } from './styles';

export function CognitoAuthWidget({
  buttonColor = 'ginger',
  buttonHoverColor = 'green'
}: WidgetProps & SharedProps) {
  const { isAuthenticated } = useAuthContext();
  const router = useRouter();

  return (
    <Flexbox>
      {!isAuthenticated ? (
        <>
          <Box paddingRight="xs">
            <TransparentButton
              role="link"
              cfButtonColor="transparent"
              cfButtonHoverColor="transparent"
              aria-label="Sign in to Greenlight for Classrooms"
              data-testid="signIn-btn"
              onClick={() => router.push('/classrooms/lesson-library/u/login')}
            >
              Sign in
            </TransparentButton>
          </Box>
          <Button
            role="link"
            cfButtonColor={buttonColor as CFColorTokenProp}
            cfButtonHoverColor={buttonHoverColor as CFColorTokenProp}
            aria-label="Sign up for Greenlight for Classrooms"
            data-testid="signUp-btn"
            onClick={() => router.push('/classrooms/lesson-library/u/register')}
          >
            Sign up
          </Button>
        </>
      ) : (
        <Button
          role="link"
          cfButtonColor={buttonColor as CFColorTokenProp}
          cfButtonHoverColor={buttonHoverColor as CFColorTokenProp}
          aria-label="Go to Greenlight for Classrooms Lesson Library"
          data-testid="go-to-library-btn"
          onClick={() => router.push('/classrooms/lesson-library')}
        >
          <Text fontSize="s">Go to library</Text>
        </Button>
      )}
    </Flexbox>
  );
}
